<template>
  <hel-module title="待决策事项" :class="scope.clsPrefix" v-loading="loading">
    <template slot="extra">
      <span class="card-tag" @click.stop="handleOpenList">全部</span>
    </template>
    <div class="card-content">
      <div v-if="loading" class="card-loading">加载中...</div>
      <template v-else-if="decision">
        <div class="content-item">
          <div class="item-header">
            <span class="item-title">{{ decision.title }}</span>
            <span class="item-tag" :class="decision.priorityClass">{{ decision.priority }}</span>
          </div>
          <div class="item-desc">{{ decision.desc }}</div>
          <div class="item-meta">
            <span>{{ decision.time.substring(0, 10) }}</span>
            <div class="meta-right">
              <span class="card-tag" @click.stop="handleOpenDetail">详情</span>
              <div class="btn-primary" @click.stop="handleSmartAnalysis">智能分析</div>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="card-empty">暂无待决策事项</div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import { getDecisionListApi } from '@/api/agentAuth'
export default {
  name: 'PendingDecisions',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-pending-decisions'
      },
      decision: null,
      loading: true
    }
  },
  created() {
    this.fetchFirstDecision()
  },
  methods: {
    async fetchFirstDecision() {
      this.loading = true
      try {
        const res = await getDecisionListApi({ reviewerAgentId: this.$store.state.cosmoClaw.currentAgentId })
        if (res && res.data && res.data.length > 0) {
          const item = res.data[0]
          this.decision = {
            id: item.id,
            title: item.title,
            desc: item.description || '',
            time: item.updateTime || item.createTime || '',
            priority: this.getPriorityText(item.priority),
            priorityClass: this.getPriorityClass(item.priority),
            rawContent: item.description || ''
          }
        }
      } catch (e) {
        console.warn('[PendingDecisions] 获取待决策事项失败:', e)
      } finally {
        this.loading = false
      }
    },
    getPriorityText(priority) {
      const map = { HIGH: '高优先级', MEDIUM: '中优先级', LOW: '低优先级' }
      return map[priority] || '待决策'
    },
    getPriorityClass(priority) {
      const map = { HIGH: 'tag-warning', MEDIUM: 'tag-medium', LOW: 'tag-low' }
      return map[priority] || ''
    },
    handleOpenDetail() {
      this.$emit('open-detail', this.decision)
    },
    handleOpenList() {
      this.$emit('open-list', this.agentId || this.reviewerAgentId || '')
    },
    handleSmartAnalysis() {
      const content = this.decision ? (this.decision.rawContent || this.decision.desc) : ''
      this.$emit('smart-analysis', {
        type: 'pendingDecision',
        content: content
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-pending-decisions";
.#{$class-prefix} {
  .card-tag {
    font-size: 12px;
    color: #4A5FF3;
    font-weight: 400;
    cursor: pointer;
  }
  .card-loading, .card-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 138px;
    font-size: 12px;
    color: #999;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    padding-bottom: 8px;
    height: 138px;
    flex: 1;
    background: #ffffffb3;
    box-shadow: 0 0 8px 0 #005ddd29;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .content-item {
    height: 100%;
    // padding: 14px;
    // background: #FAFBFC;
    // border-radius: 8px;
    display: flex;
    flex-direction: column;
  }
  .item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 13px;
    min-width: 0;
  }
  .item-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    height: 24px;
    &.tag-warning {
      background: #FFEBEE;
      color: #F44336;
    }
    &.tag-medium {
      background: #FFF3E0;
      color: #FB8C00;
    }
    &.tag-low {
      background: #E8F5E9;
      color: #43A047;
    }
  }
  .item-title {
    font-size: 13px;
    font-weight: 600;
    color: #333333;
    font-family: PingFangSC-Medium;
    min-width: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .item-desc {
    flex: 1;
    line-height: 1.5;
    // margin-bottom: 22px;
    font-family: PingFangSC-Regular;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }
  .item-meta {
    font-size: 11px;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #CCCCCC;
  }
  .meta-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .card-footer {
    display: flex;
    gap: 8px;
    padding-top: 12px;
    margin-top: 12px;
    border-top: 1px solid #F5F6F8;
    justify-content: flex-end;
  }
  .btn-action {
    padding: 4px 16px;
    border: 1px solid #4A5FF3;
    background: #fff;
    color: #4A5FF3;
    font-size: 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: PingFangSC-Regular;
    &:hover {
      background: #4A5FF3;
      color: #fff;
    }
  }
}
.btn-primary {
    // float: right;
    padding: 4px 14px;
    border: none;
    // background: #4A5FF3;
    color: #fff;
    font-size: 12px;
    // border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: PingFangSC-Regular;
    // width: 64px;
    // height: 24px;
    background-image: linear-gradient(270deg, #4A5FF3 0%, #4E86FF 100%);
    border-radius: 12px;
    // &:hover {
    //   background: #3D4FE6;
    // }
  }
</style>
